import { render, staticRenderFns } from "./TenantRole.vue?vue&type=template&id=011f4ddd&scoped=true"
import script from "./TenantRole.vue?vue&type=script&lang=js"
export * from "./TenantRole.vue?vue&type=script&lang=js"
import style0 from "./TenantRole.vue?vue&type=style&index=0&id=011f4ddd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011f4ddd",
  null
  
)

export default component.exports